module.exports = __webpack_public_path__ + "img/s1-1.302bb2b0.jpg";